export default {
    props: {
        resizableContent: {
            type: Boolean,
            default: undefined,
            kComposite: 'resizable.content'
        }, 
        resizableMin: {
            type: Number,
            default: undefined,
            kComposite: 'resizable.min'
        }, 
        resizableMax: {
            type: Number,
            default: undefined,
            kComposite: 'resizable.max'
        }, 
        resizableToolbar: {
            type: Boolean,
            default: undefined,
            kComposite: 'resizable.toolbar'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/Resizable.js